import React,{ useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { CustomDetailsList } from "../../../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../../../common/skeleton/skeleton";
import { MasterGroupMerchandiseCategoryFormController } from "../controller/controller";
import { MasterMerchandiseCategoryColumns } from "./column/column";
import { fetchMasterGroupMerchandiseCategoryList } from "../../../../../../redux/actions/resources/master/groupMerchandiseCategory/groupMerchandiseCategory";
interface IMasterGroupMerchandiseCategoryList {
    widthPopUp:any;
    heigthPopUp:any;
}
export const MasterGroupMerchandiseCategoryList:React.FC<IMasterGroupMerchandiseCategoryList> = ({heigthPopUp, widthPopUp}) => {
    const dispatch = useAppDispatch();
    const { loading, list } = useAppSelector((state) => state.masterGroupMerchandiseCategoryList);
    const renderColumns = () => {
        return MasterMerchandiseCategoryColumns();
    };

    useEffect(() => {
        list === undefined && dispatch(fetchMasterGroupMerchandiseCategoryList());
    }, [list]);

    return loading ? (
        <Skeleton rows={5}></Skeleton>
    ) : (
        <>
            <CustomDetailsList
                data={list ?? []}
                renderColumns={renderColumns}
            />
            <MasterGroupMerchandiseCategoryFormController widthPopUp={widthPopUp} heigthPopUp={heigthPopUp}/>
        </>
    );
};
